// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Layout */
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
}

/* Top Section (map and sidebar) */
.top-section {
  display: flex;
  height: 80vh;
  width: 100%;
  position: relative;
  z-index: 0;
}

/* Left Sidebar */
.left-bar {
  width: 25%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-right: 1px solid black;
  position: relative;
  z-index: 0;
}

/* Map Container */
.map-container {
  width: 75%;
  height: 100%;
  position: relative;
  z-index: 0;
}

.icon-bar {
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 1000;
  flex-direction: row; /* dôležité */
}


/* Štýl pre ikonky aj burger */
.icon-button {
  width: 36px;
  height: 36px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  object-fit: cover;
  transition: border 0.2s ease;
}

.icon-button:hover {
  border: 2px solid #999;
}

.icon-button.active {
  border: 2px solid #007bff;
}

/* BurgerMenu button musí tiež byť 36x36 */
.burger-menu-button {
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}


/* Language Flags */
.flag-icon {
  width: 32px;
  height: 22px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 3px;
  transition: border 0.2s ease;
}

.flag-icon:hover {
  border: 2px solid #999;
}

.flag-icon.active {
  border: 2px solid #007bff;
}

/* Bottom Bar */
.bottom-bar {
  position: relative;
  z-index: 1000;
  overflow: visible;
  width: 100%;
  height: 20vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-top: 1px solid black;
}

/* Bottom Bar Layout */
.bottom-bar__wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 80%;
}

.bottom-bar__labels {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 25%;
  text-align: right;
  padding-right: 10px;
}

.bottom-bar__lines {
  flex-grow: 1;
}

.bottom-bar__months {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid black;
  background-color: #f9f9f9;
  width: 100%;
  padding-top: 5px;
}

/* Responsive Adjustments */
@media screen and (max-width: 1160px) {
  .left-bar {
    width: 25% !important;
  }

  .map-container {
    width: 75% !important;
  }
}

@media screen and (max-width: 780px) {
  .left-bar {
    display: none !important;
  }

  .bottom-bar {
    display: none !important;
  }

  .map-container {
    width: 100% !important;
    height: 100vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB,EAAE,aAAa;AACpC;;;AAGA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF","sourcesContent":["/* App Layout */\n.app-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n}\n\n/* Top Section (map and sidebar) */\n.top-section {\n  display: flex;\n  height: 80vh;\n  width: 100%;\n  position: relative;\n  z-index: 0;\n}\n\n/* Left Sidebar */\n.left-bar {\n  width: 25%;\n  height: 100%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid black;\n  position: relative;\n  z-index: 0;\n}\n\n/* Map Container */\n.map-container {\n  width: 75%;\n  height: 100%;\n  position: relative;\n  z-index: 0;\n}\n\n.icon-bar {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  z-index: 1000;\n  flex-direction: row; /* dôležité */\n}\n\n\n/* Štýl pre ikonky aj burger */\n.icon-button {\n  width: 36px;\n  height: 36px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  border-radius: 4px;\n  object-fit: cover;\n  transition: border 0.2s ease;\n}\n\n.icon-button:hover {\n  border: 2px solid #999;\n}\n\n.icon-button.active {\n  border: 2px solid #007bff;\n}\n\n/* BurgerMenu button musí tiež byť 36x36 */\n.burger-menu-button {\n  width: 36px;\n  height: 36px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n/* Language Flags */\n.flag-icon {\n  width: 32px;\n  height: 22px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  border-radius: 3px;\n  transition: border 0.2s ease;\n}\n\n.flag-icon:hover {\n  border: 2px solid #999;\n}\n\n.flag-icon.active {\n  border: 2px solid #007bff;\n}\n\n/* Bottom Bar */\n.bottom-bar {\n  position: relative;\n  z-index: 1000;\n  overflow: visible;\n  width: 100%;\n  height: 20vh;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  border-top: 1px solid black;\n}\n\n/* Bottom Bar Layout */\n.bottom-bar__wrapper {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 80%;\n}\n\n.bottom-bar__labels {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 25%;\n  text-align: right;\n  padding-right: 10px;\n}\n\n.bottom-bar__lines {\n  flex-grow: 1;\n}\n\n.bottom-bar__months {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid black;\n  background-color: #f9f9f9;\n  width: 100%;\n  padding-top: 5px;\n}\n\n/* Responsive Adjustments */\n@media screen and (max-width: 1160px) {\n  .left-bar {\n    width: 25% !important;\n  }\n\n  .map-container {\n    width: 75% !important;\n  }\n}\n\n@media screen and (max-width: 780px) {\n  .left-bar {\n    display: none !important;\n  }\n\n  .bottom-bar {\n    display: none !important;\n  }\n\n  .map-container {\n    width: 100% !important;\n    height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
